








































import { Component, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { find } from 'lodash'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import UpdateOrderMemoOrderInfo from '@/components/organisms/UpdateOrderMemoOrderInfo'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  defaultOrderMemo,
  defaultSimpleBibliographyReal,
  defaultSystemCode,
  ErrorMessage,
  orderApi,
  OrderMemo,
  SimpleBibliographyReal,
  SystemCode
} from '@/api'
import { UpdateOrderMemoOrderInfoItem } from '@/components/organisms/UpdateOrderMemoOrderInfo/index.type'
import { CODE_KEY } from '@/config'
import {
  alertStore,
  modalErrorStore,
  modalUpdateOrderMemoStore,
  systemCodeStore
} from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { AlertFactory } from '@/factory'
import {
  UpdateMemoInputInfo,
  defaultUpdateMemoInputInfoItem,
  UpdateMemoInputInfoItem
} from '@/components/organisms/UpdateMemoInputInfo'
import { AlertCodeALC00002, SearchType } from '@/types'
import { BibliographyRealInfoMagazine } from '@/components/organisms/BibliographyRealInfoMagazine'
import { UpdateMemoBibliographyInfo } from '@/components/organisms/UpdateMemoBibliographyInfo'

@Component({
  components: {
    UpdateMemoBibliographyInfo,
    BibliographyRealInfoMagazine,
    UpdateMemoInputInfo,
    UpdateOrderMemoOrderInfo,
    ModalFooter
  }
})
export default class ModalUpdateOrderMemo extends ComponentVue {
  simpleBibliographyReal: SimpleBibliographyReal = defaultSimpleBibliographyReal()

  orderMemo: OrderMemo = defaultOrderMemo()

  orderMemoInfoItem: UpdateMemoInputInfoItem = defaultUpdateMemoInputInfoItem()

  get isMagazine(): boolean {
    return this.simpleBibliographyReal.searchType.code === SearchType.Magazine
  }

  get isOpen(): boolean {
    return modalUpdateOrderMemoStore.isOpen
  }

  get bibliographyRealId(): number {
    return modalUpdateOrderMemoStore.bibliographyRealId
  }

  get orderId(): number {
    return modalUpdateOrderMemoStore.orderId
  }

  get orderInfoItem(): UpdateOrderMemoOrderInfoItem {
    return {
      orderId: this.orderMemo.orderId,
      buyBranchCode: this.orderMemo.buyBranchCode,
      callNo: this.orderMemo.callNo,
      shelfType: this.orderMemo.shelfType,
      collectionType: this.orderMemo.collectionType,
      status: this.orderMemo.status,
      handlingType: this.orderMemo.handlingType,
      appendixCode: this.orderMemo.appendixCode,
      updatedTime: this.orderMemo.updatedTime,
      updatedBranchCode: this.orderMemo.updatedBranchCode
    }
  }

  get SystemCodesOfOrderMemo(): SystemCode[] {
    return systemCodeStore.getOrderMemo
  }

  get systemCodesOfOrderMemoFindByWorkMemoCode(): SystemCode | undefined {
    return find<SystemCode>(this.SystemCodesOfOrderMemo, {
      code: this.orderMemoInfoItem.workMemoCode ?? ''
    })
  }

  get systemCodesOfOrderMemoFindByDisplayMemoCode(): SystemCode | undefined {
    return find<SystemCode>(this.SystemCodesOfOrderMemo, {
      code: this.orderMemoInfoItem.displayMemoCode ?? ''
    })
  }

  get systemCodesOfOrderMemoFindByLocalMemoCode(): SystemCode | undefined {
    return find<SystemCode>(this.SystemCodesOfOrderMemo, {
      code: this.orderMemoInfoItem.localMemoCode ?? ''
    })
  }

  @Watch('isOpen')
  initialize(newVal: boolean): void {
    if (newVal) {
      systemCodeStore.fetchAllAndMergeByCodeKeys([CODE_KEY.COLLECTION_MEMO.KEY])

      this.getSimpleBibliographyReal()
      this.callApiGetOrderMemo()
      return
    }

    this.simpleBibliographyReal = defaultSimpleBibliographyReal()
    this.orderMemo = defaultOrderMemo()
    this.orderMemoInfoItem = defaultUpdateMemoInputInfoItem()
  }

  onClickCancel(): void {
    const alert: Alert = AlertFactory.create(AlertCodeALC00002)
    alertStore.setItem(alert)

    this.$modalAlert.open({
      onOkClick: modalUpdateOrderMemoStore.close
    })
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-update-order-memo')

    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  async getSimpleBibliographyReal(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      this.simpleBibliographyReal = await bibliographyRealApi.getSimpleBibliographyReal(
        this.bibliographyRealId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async callApiGetOrderMemo(): Promise<void> {
    try {
      this.orderMemo = await orderApi.getOrderMemoById({
        orderId: this.orderId
      })
      this.orderMemoInfoItem = {
        workMemoCode: '',
        workMemo: this.orderMemo.workMemo,
        workMemoTime: this.orderMemo.workMemo
          ? this.orderMemo.workMemoTime
          : '',
        workMemoBranchCode: this.orderMemo.workMemo
          ? this.orderMemo.workMemoBranchCode
          : defaultSystemCode(),
        displayMemoCode: '',
        displayMemo: this.orderMemo.displayMemo,
        displayMemoTime: this.orderMemo.displayMemo
          ? this.orderMemo.displayMemoTime
          : '',
        displayMemoBranchCode: this.orderMemo.displayMemo
          ? this.orderMemo.displayMemoBranchCode
          : defaultSystemCode(),
        localMemoCode: '',
        localMemo: this.orderMemo.localMemo,
        localMemoTime: this.orderMemo.localMemo
          ? this.orderMemo.localMemoTime
          : '',
        localMemoBranchCode: this.orderMemo.localMemo
          ? this.orderMemo.localMemoBranchCode
          : defaultSystemCode()
      }
    } catch (error) {
      modalUpdateOrderMemoStore.close()
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async callApiUpdateOrderMemo(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await orderApi.updateOrderMemo({
        id: this.orderMemo.orderId ?? 0,
        workMemo: this.orderMemoInfoItem.workMemo ?? '',
        displayMemo: this.orderMemoInfoItem.displayMemo ?? '',
        localMemo: this.orderMemoInfoItem.localMemo ?? '',
        revision: this.orderMemo.revision ?? 1
      })
      modalUpdateOrderMemoStore.updated()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
